import React, { useState,useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getPowerData } from 'src/apis/influxdata';
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import { Grid, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import moment from "moment";
const ChartWithDatePicker = ({siteId, buildingId}) => {
  const today = new Date();
  const yesterday =today.setDate(today.getDate() - 1);
  const [startDate, setStartDate] = useState(new Date(yesterday));
  const [endDate, setEndDate] = useState(new Date());
  const [graphPoints,setGraphPoints] = useState([])

  const [options,setOptions] = useState({
    title: {
      text: 'Trend of Active Power Absorbed (kWatts)',
      style: {
        color: '#fff', // Set the title color here
      },
    },
    chart: {
      backgroundColor: '#282B30', // Set the background color here
    },
    xAxis: {
      
      type: 'datetime',
      labels: {
        style: {
          color: '#fff', // Set the labels color here
        },
      },
    },
    yAxis: {
    
      title: {
        text: 'Power',
        style: {
          color: '#fff', // Set the yAxis title color here
        },
      },
      labels: {
        style: {
          color: '#fff', // Set the labels color for the yAxis here
        },
      },
    },
    series: [
      {  
        type:"line",
        curveFactor:0.7,
        name: 'Active power',
        data: []
      },
    ],
  });


  const fetchPoints = async (body) => {
    try {
       await getPowerData(body).then((res) => {
        if(res){
          const matrix = res.map((point) => {
            return [new Date(point.time).getTime(), point.values.value];
          });
          const updatedOptions = {
            ...options, // Copy the existing options
            series: [
              {
                ...options.series[0], // Copy the existing series
                data: matrix, // Update the data property with the new value
              },
            ],
          };
  
          // Update the options state with the modified value
          setOptions(updatedOptions);
      }
    });
   } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const apiBody={}
    if(siteId){
       apiBody["start"]=moment(startDate).format("YYYY-MM-DD HH:mm:ss");
       apiBody["end"]=moment(endDate).format("YYYY-MM-DD HH:mm:ss");
       apiBody["siteId"]=siteId;
    }
    if(apiBody.siteId){
      fetchPoints(apiBody);
    }
    
  }, [endDate]);
 



  const handleDateChange = (date, isStartDate) => {
    if (isStartDate) {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
  };


  return (
    <div>
      
      <Grid container>
        <Grid item md={6} lg={6}>
        From: <DatePicker
        selected={startDate}
        onChange={(date) => handleDateChange(date, true)}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        dateFormat="yyyy-MM-dd"
      />
        </Grid>
        <Grid item md={6} lg={6}>
        To: <DatePicker
        selected={endDate}
        onChange={(date) => handleDateChange(date, false)}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        dateFormat="yyyy-MM-dd"
      />
        </Grid>
        
      </Grid>
      
      
      <div>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </div>
  );
};

export default ChartWithDatePicker;
